import { flowRight } from "lodash";
import { connect } from "react-redux";

import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import { RootState } from "store/store";

import withLoader from "hocs/withLoader/withLoader";
import withError from "hocs/withError/withError";

import ActivityLog from "./ActivityLog";

const mapStateToProps = (state: RootState) => ({
    envMoniker: getActiveEnvironmentMoniker(state),
    tenantMoniker: state.tenantsReducer.activeTenant.moniker,
    tenantId: state.tenantsReducer.activeTenant.versionInfo.id,
});

const Container = connect(mapStateToProps, {})(ActivityLog);

const ActivityLogContainer = flowRight(withLoader, withError)(Container);

export default ActivityLogContainer;
